import { render } from "./SidenavList.vue?vue&type=template&id=5a462273&scoped=true"
import script from "./SidenavList.vue?vue&type=script&lang=js"
export * from "./SidenavList.vue?vue&type=script&lang=js"

import "./SidenavList.vue?vue&type=style&index=0&id=5a462273&scoped=true&lang=css"

import exportComponent from "C:\\Users\\yordis.escorcia\\Downloads\\relojito\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a462273"]])

export default __exports__